import { createAsyncThunk } from '@reduxjs/toolkit';
import getCredentials from '../../utils/getCredentials';
import setSendBulletin from 'scenes/BulletinBoard/utils/setSendBulletin';

export const sendBulletin = createAsyncThunk(
  'bulletinBoard/sendBulletin',
  async (body, { getState }) => {

    const projectId = getState().projects.selectedProjectId;

    const { accessKeyId, secretAccessKey, sessionToken } =
      await getCredentials();

    const params = {
      accessKeyId,
      secretAccessKey,
      sessionToken,
    };

    const response = await setSendBulletin(body, params, projectId);

    // The id travels with the answer so the slice can stamp the bulletin sent
    // — and published, which a send does — without a refetch.
    return { response, bulletinId: body.bulletinId };
  }
);
